import React, { Component } from 'react'
import { Message } from 'semantic-ui-react'

import '../../../node_modules/semantic-ui-css/components/message.css'

export default class MessageComponent extends Component {

  render () {
    return (
      <Message
        error
        className='messageWidth90'
        compact
        content="Sorry, we couldn't find a user by that name and password. Please try again."
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/auth/components/MessageComponent.js